import {Injectable} from "@angular/core";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {
    CreateShareProductsLinkWsMapper
} from "@app/core/product/infrastructure/services/ws/mappers/create-share-products-link-ws.mapper";

@Injectable({
    providedIn: 'root'
})
export class CreateSharedProductsLinkWs {

    private readonly mapper = new CreateShareProductsLinkWsMapper();
    private static readonly LINK_KEY = 'link';

    constructor(
        private handler: EuropastryBaseHandler,
        private apiUrls: ApiUrls,
    ) {}

    execute(link: string): Observable<string> {
        const parameters = new HandlerBuilder()
            .method(HttpMethod.post)
            .url(`${this.apiUrls.SHARE_PRODUCT_LINK}`)
            .body({
                [CreateSharedProductsLinkWs.LINK_KEY]: link,
            })
            .build();
        return this.handler.execute(parameters).pipe(
            map(response => this.mapper.mapFromJson(response))
        );
    }
}